import React, { Component } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import gql from 'graphql-tag';
import moment from 'moment';
import * as Cookies from 'es-cookie';
import { withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';

const GET_MONTHLY_ATTENDANCE_REPORT = gql`
  query getMonthlyAttendanceReport(
    $academic_year_id: Int!
    $institute_id: Int!
    $branch_id: Int!
    $class_id: Int!
    $section_id: String
    $month: String
  ) {
    getMonthlyAttendanceReport(
      academic_year_id: $academic_year_id
      institute_id: $institute_id
      branch_id: $branch_id
      class_id: $class_id
      section_id: $section_id
      month: $month
    ) {
      student_id
      admission_no
      student_name
      student_mobile
      roll_no
      class_id
      section_id
      branch_id
      total_present
      total_absent
      total_working_days
      percentage
      days {
        day
        status
      }
    }
  }
`;

const GET_ACADEMIC_PERFORMANCE_REPORT = gql`
  query getStudentAcademicPerformanceReport($student_id: Int!) {
    getStudentAcademicPerformanceReport(student_id: $student_id) {
      exam_phase
      academic_year
      academic_year_id
      exam_standard
      student_id
      student_name
      gender
      roll_no
      admission_no
      subjects {
        subject
        subject_id
        color_code
        marks
        internal_max_marks
        class_id
        class_name
        exam_phase_internals
        grade
        grade_point
      }
    }
  }
`;

const SnapshotAlert = ({ icon, text, linkText, type, onLinkClick }) => {
    let bgColor = '#fffbeb';
    let borderColor = '#fef3c7';
    let textColor = '#b45309';
    let iconColor = '#d97706';
    let borderLeftColor = '#f59e0b';

    if (type === 'danger') {
        bgColor = '#fef2f2';
        borderColor = '#fee2e2';
        textColor = '#b91c1c';
        iconColor = '#ef4444';
        borderLeftColor = '#ef4444';
    } else if (type === 'success') {
        bgColor = '#f0fdf4';
        borderColor = '#dcfce7';
        textColor = '#15803d';
        iconColor = '#10b981';
        borderLeftColor = '#10b981';
    }

    return (
        <div className="d-flex align-items-center p-3 mb-3" style={{
            background: bgColor,
            border: `1px solid ${borderColor}`,
            borderLeft: `5px solid ${borderLeftColor}`,
            borderRadius: '10px',
            fontSize: '13px',
            color: textColor,
            fontWeight: '500',
            gap: '12px'
        }}>
            <i className={icon} style={{ fontSize: '15px', color: iconColor }}></i>
            <div className="flex-grow-1">
                {text} {linkText && <span onClick={onLinkClick} style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: '700', marginLeft: '4px' }}>{linkText}</span>}
            </div>
        </div>
    );
};

class StudentSnapshot extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attendanceData: null,
            performanceData: [],
            loading: false
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.student?.student_id !== this.props.student?.student_id) {
            this.fetchData();
        }
    }

    fetchData = async () => {
        const { student, client } = this.props;
        if (!student || !client) return;

        this.setState({ loading: true });
        try {
            const institutionId = parseInt(Cookies.get("institutionid"));
            const academicYearId = student?.academic_year_id ? student?.academic_year_id : 2;
            const branchId = parseInt(student.branch);
            const classId = parseInt(student.class);
            const sectionId = student.section ? student.section.toString() : "";

            if (!institutionId || !branchId || !classId || !sectionId) {
                this.setState({ loading: false });
                return;
            }

            // Fetch attendance and academic performance in parallel
            const [attendanceResult, performanceResult] = await Promise.all([
                client.query({
                    query: GET_MONTHLY_ATTENDANCE_REPORT,
                    variables: {
                        academic_year_id: academicYearId,
                        institute_id: institutionId,
                        branch_id: branchId,
                        class_id: classId,
                        section_id: sectionId,
                        month: moment().format("YYYY-MM")
                    },
                    fetchPolicy: 'network-only',
                }),
                client.query({
                    query: GET_ACADEMIC_PERFORMANCE_REPORT,
                    variables: { student_id: parseInt(student.student_id) },
                    fetchPolicy: 'network-only'
                })
            ]);

            const list = attendanceResult.data?.getMonthlyAttendanceReport || [];
            const studentData = list.find(s => parseInt(s.student_id) === parseInt(student.student_id));

            this.setState({
                attendanceData: studentData || null,
                performanceData: performanceResult.data?.getStudentAcademicPerformanceReport || [],
                loading: false
            });
        } catch (error) {
            console.error("Error fetching data in snapshot:", error);
            this.setState({ loading: false });
        }
    };

    render() {
        const { student, feeReport, feeLoading } = this.props;
        const { attendanceData, performanceData, loading } = this.state;

        const studentName = student?.student_name || "Aarav Sharma";
        const firstName = studentName.split(' ')[0];

        // 1. Attendance Metrics
        const attendancePct = attendanceData ? parseFloat(attendanceData.percentage).toFixed(1) : "82.5";
        const absences = attendanceData ? attendanceData.total_absent : 8;
        const lateArrivals = attendanceData?.days ? attendanceData.days.filter(d => d.status === 'L' || d.status === 'LA').length : 4;
        const isBelowTarget = parseFloat(attendancePct) < 85;

        const isFeeLoading = feeLoading;

        // 2. Fee Metrics
        let dueAmount = 0;
        let dueDate = "";
        let hasUnpaid = false;
        if (feeReport && feeReport.length > 0) {
            for (const type of feeReport) {
                for (const term of (type.terms || [])) {
                    const total = parseInt(term.term_amount) || 0;
                    const paid = parseInt(term.paid_amount) || 0;
                    const pending = total - paid;
                    if (pending > 0) {
                        dueAmount += pending;
                        if (term.term_date && !dueDate) {
                            dueDate = moment(term.term_date).format("DD MMM YYYY");
                            hasUnpaid = true;
                        }
                    }
                }
            }
        }


        const reminderDate = (dueDate && moment(dueDate, "DD MMM YYYY").isValid())
            ? moment(dueDate, "DD MMM YYYY").subtract(2, 'days').format("DD MMM")
            : "18 May";

        // 3. Dynamic Trophy Alert Text
        let trophyText = "";
        let highestSubject = "";
        let highestMark = 0;
        if (performanceData && performanceData.length > 0) {
            const subjectMarks = {};
            performanceData.forEach(phase => {
                (phase.subjects || []).forEach(sub => {
                    if (sub.subject) {
                        if (!subjectMarks[sub.subject]) {
                            subjectMarks[sub.subject] = [];
                        }
                        subjectMarks[sub.subject].push(parseFloat(sub.marks) || 0);
                    }
                });
            });
            Object.keys(subjectMarks).forEach(sub => {
                const marks = subjectMarks[sub];
                const avg = marks.reduce((a, b) => a + b, 0) / marks.length;
                if (avg > highestMark) {
                    highestMark = avg;
                    highestSubject = sub;
                }
            });
        }
        if (highestSubject) {
            trophyText = `Top Performance in ${highestSubject} — average score of ${Math.round(highestMark)}% this academic year. Keep up the great work!`;
        } else {
            trophyText = `${firstName} shows consistent learning engagement and positive class participation across all subjects.`;
        }

        // 4. Dynamic Subject Grades Calculation
        let gradesList = [];
        if (performanceData && performanceData.length > 0) {
            const latestPhase = performanceData[performanceData.length - 1];
            const subjects = latestPhase.subjects || [];
            
            const sortedSubjects = [...subjects].sort((a, b) => (parseFloat(b.marks) || 0) - (parseFloat(a.marks) || 0));

            if (sortedSubjects.length > 0) {
                gradesList = sortedSubjects.slice(0, 3).map((sub, idx) => ({
                    grade: sub.grade || "—",
                    subject: sub.subject,
                    examPhase: latestPhase.exam_phase,
                    examPhaseInternal: sub.exam_phase_internals || "Marks",
                    variant: idx === 0 ? 'success' : idx === 1 ? 'primary' : 'warning'
                }));
            }
        }


        return (
            <div>
                <style>{`
                    .fee-shimmer {
                        background: #f6f7f8;
                        background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
                        background-repeat: no-repeat;
                        background-size: 800px 104px;
                        display: inline-block;
                        position: relative;
                        animation-duration: 1.2s;
                        animation-fill-mode: forwards;
                        animation-iteration-count: infinite;
                        animation-name: placeholderShimmer;
                        animation-timing-function: linear;
                    }
                    @keyframes placeholderShimmer {
                        0% { background-position: -468px 0; }
                        100% { background-position: 468px 0; }
                    }
                `}</style>

                {/* Custom Alert Banners */}
                {loading ? (
                    <div className="fee-shimmer mb-3" style={{ width: '100%', height: '54px', borderRadius: '10px' }}></div>
                ) : (
                    <SnapshotAlert
                        icon="fas fa-exclamation-triangle"
                        text={`Attendance is ${attendancePct}% — ${isBelowTarget ? 'below' : 'above'} the 85% promotion threshold. ${absences} absences and ${lateArrivals} late arrivals this term.`}
                        linkText="View calendar →"
                        type="warning"
                        onLinkClick={() => this.props.history.push({ pathname: "/student-profile-details/attendance", state: this.props.location?.state })}
                    />
                )}

                {isFeeLoading ? (
                    <div className="fee-shimmer mb-3" style={{ width: '100%', height: '54px', borderRadius: '10px' }}></div>
                ) : (
                    hasUnpaid && dueAmount > 0 && (
                        <SnapshotAlert
                            icon="fas fa-rupee-sign"
                            text={`Fee instalment ₹${dueAmount.toLocaleString()} is due on ${dueDate}. Auto-reminder scheduled for parent on ${reminderDate}.`}
                            linkText="Collect fee →"
                            type="danger"
                            onLinkClick={() => this.props.history.push({ pathname: "/student-profile-details/fees", state: this.props.location?.state })}
                        />
                    )
                )}

                {loading ? (
                    <div className="fee-shimmer mb-3" style={{ width: '100%', height: '54px', borderRadius: '10px' }}></div>
                ) : (
                    <SnapshotAlert
                        icon="fas fa-trophy"
                        text={trophyText}
                        linkText="View academic performance →"
                        type="success"
                        onLinkClick={() => this.props.history.push({ pathname: "/student-profile-details/academic", state: this.props.location?.state })}
                    />
                )}

                <h5 className="mb-4 mt-4 text-dark font-weight-bold">Student Progress Snapshot</h5>
                {loading || isFeeLoading ? (
                    <Row>
                        <Col lg={8} className="mb-4">
                            <Card className="border-0 shadow-sm p-4 mb-4" style={{ borderRadius: '12px', minHeight: '232px' }}>
                                <div className="fee-shimmer mb-3" style={{ width: '180px', height: '18px', borderRadius: '4px' }}></div>
                                <div className="fee-shimmer mb-2" style={{ width: '100%', height: '14px', borderRadius: '4px' }}></div>
                                <div className="fee-shimmer mb-3" style={{ width: '90%', height: '14px', borderRadius: '4px' }}></div>
                                <hr />
                                <Row className="text-center mt-3">
                                    <Col xs={4}>
                                        <div className="fee-shimmer mb-2" style={{ width: '50px', height: '24px', borderRadius: '4px' }}></div>
                                        <div className="fee-shimmer" style={{ width: '80px', height: '12px', borderRadius: '4px' }}></div>
                                    </Col>
                                    <Col xs={4} style={{ borderLeft: '1px solid #f1f2f5', borderRight: '1px solid #f1f2f5' }}>
                                        <div className="fee-shimmer mb-2" style={{ width: '50px', height: '24px', borderRadius: '4px' }}></div>
                                        <div className="fee-shimmer" style={{ width: '80px', height: '12px', borderRadius: '4px' }}></div>
                                    </Col>
                                    <Col xs={4}>
                                        <div className="fee-shimmer mb-2" style={{ width: '50px', height: '24px', borderRadius: '4px' }}></div>
                                        <div className="fee-shimmer" style={{ width: '80px', height: '12px', borderRadius: '4px' }}></div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col lg={4} className="mb-4">
                            <Card className="border-0 shadow-sm p-4" style={{ borderRadius: '12px', background: '#eff6ff', borderLeft: '5px solid #2563eb', minHeight: '232px' }}>
                                <div className="fee-shimmer mb-3" style={{ width: '120px', height: '16px', borderRadius: '4px' }}></div>
                                <div className="fee-shimmer mb-2" style={{ width: '100%', height: '12px', borderRadius: '4px' }}></div>
                                <div className="fee-shimmer mb-3" style={{ width: '80%', height: '12px', borderRadius: '4px' }}></div>
                                <div className="d-flex align-items-center mt-3">
                                    <div className="fee-shimmer rounded-circle" style={{ width: '32px', height: '32px' }}></div>
                                    <div className="ml-2 flex-grow-1">
                                        <div className="fee-shimmer mb-1" style={{ width: '100px', height: '12px', borderRadius: '4px' }}></div>
                                        <div className="fee-shimmer" style={{ width: '80px', height: '10px', borderRadius: '4px' }}></div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    <Row>
                        <Col lg={8} className="mb-4">
                            <Card className="border-0 shadow-sm p-4 mb-4" style={{ borderRadius: '12px' }}>
                                <h6 className="font-weight-bold text-secondary mb-3">Recent Performance Overview</h6>
                                <p className="text-muted">
                                    {firstName} has shown outstanding academic aptitude this term, keeping a strong focus in analytical and computational subjects.
                                    His class involvement and homework completion are exemplary, though slight improvement in writing speeds during exams will help him score even better.
                                </p>
                                <hr />
                                <Row className="text-center mt-3">
                                    {gradesList.length > 0 ? gradesList.map((item, idx) => (
                                        <Col key={idx} xs={4} style={{ borderLeft: idx === 1 ? '1px solid #f1f2f5' : 'none', borderRight: idx === 1 ? '1px solid #f1f2f5' : 'none' }}>
                                            <h4 className={`font-weight-bold text-${item.variant} mb-1`}>{item.grade}</h4>
                                            <span className="text-muted small font-weight-bold d-block">{item.subject}</span>
                                            <span className="text-secondary d-block" style={{ fontSize: '11px', marginTop: '2px' }}>
                                                {item.examPhase} - {item.examPhaseInternal}
                                            </span>
                                        </Col>
                                    )) : (
                                        <Col xs={12}>
                                            <span className="text-muted small">No recent academic performance records found.</span>
                                        </Col>
                                    )}
                                </Row>
                            </Card>
                        </Col>
                        <Col lg={4} className="mb-4">
                            <Card className="border-0 shadow-sm p-4" style={{ borderRadius: '12px', background: '#eff6ff', borderLeft: '5px solid #2563eb' }}>
                                <h6 className="font-weight-bold text-primary mb-2">Teacher's Remark</h6>
                                <p className="text-secondary small mb-3">
                                    "{firstName} is a highly inquisitive student who loves solving mathematical puzzles. He works collaboratively in teams and contributes positively to class activities."
                                </p>
                                <div className="d-flex align-items-center">
                                    <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center font-weight-bold" style={{ width: '32px', height: '32px', fontSize: '0.8rem' }}>
                                        {firstName.substring(0, 2).toUpperCase()}
                                    </div>
                                    <div className="ml-2">
                                        <div className="font-weight-bold text-dark small">Mrs. Meera Kapoor</div>
                                        <div className="text-muted small" style={{ fontSize: '0.75rem' }}>Class Teacher, Grade {student?.class_name || "6"} - Section {student?.section_name || "A"}</div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                )}
            </div>
        );
    }
}
export default withRouter(withApollo(StudentSnapshot));